<template>
<div class="chapter">
<div class="inner_page">
<p class="title" id="title"><b>Hell and Beyond<br/>A Novel</b></p>
<p class="auth">Michael Phillips</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hell_and_Beyond_Split1.vue?55b4f5c6